import updateCart from './updateCart';

function updateAddress({ axios, cartId, address }) {
  const payload = {};
  if (address.id) {
    payload.address = address.id;
  } else {
    const { latitude, longitude } = address;
    payload.lat = latitude;
    payload.lng = longitude;
  }

  return updateCart({ axios, cartId, payload });
}

export default updateAddress;
